import { getData } from "../api/api";
import { PagedModel, QuotaStatusResponse, UsageStat } from "../types/subscription";

const BASE_URL = "/quota";

export const quotaService = {
  myQuota: async () => {
    return getData(`${BASE_URL}/my`) as Promise<QuotaStatusResponse>;
  },

  quotaByUsername: async (username: string) => {
    return getData(`${BASE_URL}/by-username?username=${encodeURIComponent(username)}`) as Promise<
      QuotaStatusResponse
    >;
  },

  myStats: async (page: number = 0, size: number = 20) => {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
      sort: "usedAt,desc",
    });
    return getData(`${BASE_URL}/my/stats?${params.toString()}`) as Promise<PagedModel<UsageStat>>;
  },

  statsByUsername: async (username: string, page: number = 0, size: number = 20) => {
    const params = new URLSearchParams({
      username,
      page: String(page),
      size: String(size),
      sort: "usedAt,desc",
    });
    return getData(`${BASE_URL}/stats/by-username?${params.toString()}`) as Promise<
      PagedModel<UsageStat>
    >;
  },
};

